import { Controller } from "stimulus"
import Sortable from "sortablejs"
import Rails from "@rails/ujs"
import t from "../i18n"

export default class extends Controller {
	connect() {
		this.sortable = Sortable.create(this.element, {
			group: {
				name: this.data.get("group") || "project-kanban",
				pull: true,
				put: true
			},
			animation: 150,
			ghostClass: "project-kanban-card--dragging",
			onEnd: this.end.bind(this)
		});
	}

	end(event) {
		this.syncEmptyStates(event.from, event.to);

		let targetUrl = event.to.dataset.dragColumnUrl;
		if (targetUrl) {
			this.applyColumnRules(event, targetUrl);
			return;
		}

		let id = event.item.dataset.id;
		let newStatus = event.to.id;

		let data = new FormData();
		data.append("status", newStatus);

		Rails.ajax({
			url: this.data.get("url").replace(":id", id),
			type: "PATCH",
			data: data,
			success: () => {
				console.log("Status updated successfully");
			},
			error: (err) => {
				this.revertMove(event);
				this.syncEmptyStates(event.from, event.to);
				console.error("Failed to update status", err);
			}
		});
	}

	applyColumnRules(event, targetUrl) {
		let data = new FormData();
		if (event.item.dataset.id) data.append("lead_id", event.item.dataset.id);
		if (event.item.dataset.leadIds) data.append("lead_ids", event.item.dataset.leadIds);

		Rails.ajax({
			url: targetUrl,
			type: "PATCH",
			data: data,
			success: () => {},
			error: () => {
				this.revertMove(event);
				this.syncEmptyStates(event.from, event.to);
				alert(t("kanban.rule_missing", {}, "Diese Spalte hat keine eindeutige Zielregel. Bitte im Kanban-Editor z. B. genau einen Status oder Betreuer hinterlegen."));
			}
		});
	}

	revertMove(event) {
		if (!event.from || !event.item) return;

		const referenceNode = event.from.children[event.oldIndex] || null;
		event.from.insertBefore(event.item, referenceNode);
	}

	syncEmptyStates(...columns) {
		columns.forEach((column) => {
			if (!column) return;

			const cards = column.querySelectorAll(".project-kanban-card");
			const emptyStates = column.querySelectorAll(".project-kanban-empty");

			if (cards.length > 0) {
				emptyStates.forEach((emptyState) => emptyState.remove());
				return;
			}

			if (emptyStates.length === 0 && column.dataset.emptyText) {
				const emptyState = document.createElement("div");
				emptyState.className = "project-kanban-empty";
				emptyState.textContent = column.dataset.emptyText;
				column.appendChild(emptyState);
			}
		});
	}
}
